<template>
  <div class="basic_wrap funds-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('moneybag.myWallet') }}
      </div>
    </div>

    <van-empty
      v-if="listShow"
      :description="$t('moneybag.detailsEmpty')"
    />
    <div
      v-else
      class="detail_box"
    >
      <article
        v-for="(item, index) in visibleList"
        :key="item.id || item.time || index"
        class="record-card"
      >
        <div class="de_wrap">
          <p class="tit">
            {{ item[lang] }}
          </p>
          <p class="time">
            {{ item.time }}
          </p>
        </div>
        <div
          class="price"
          :class="item.type == '1' ? 'is-income' : 'is-outcome'"
        >
          {{ formatFundAmount(item) }}
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Empty } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty);

export default {
	name: "Funds",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: [],
			list: {},
			account: 0,
			option: [],
			listShow: false,
			funds: 0,
			frozen: 0,
			mymoney: 0,
			userName: "",
		};
	},
	computed: {
		visibleList() {
			var list = this.data || [];

			return list.filter(function(item) {
				return String(item.show) === "1";
			});
		},
	},
	created() {
		this.$parent.footer("moneybag");
	},
	mounted() {
		Fetch("/user/funds").then(r => {
			this.option.push({
				text: this.$t("moneybag.types"),
				value: 0,
			});

			for (var key in r.data.reason) {
				r.data.reason[key] = this.translateReason(key, r.data.reason[key]);
				this.option.push({
					text: r.data.reason[key],
					value: key,
				});
			}

			this.showError(r.data.list.length);
			this.data = r.data.list;
			this.funds = parseInt(1 * r.data.money + 1 * r.data.wx_bankbz);
			this.mymoney = r.data.mymoney;
			this.frozen = r.data.basemoney;
			this.userName = r.data.username;
			this.listd(1);
		});
	},
	methods: {
		translateReason(key, fallback) {
			switch (key) {
			case "1":
				return this.$t("moneybag.recharge");
			case "2":
				return this.$t("moneybag.withdraw");
			case "3":
				return this.$t("moneybag.give");
			case "4":
				return this.$t("moneybag.signIn");
			case "5":
				return this.$t("moneybag.share");
			case "6":
				return this.$t("moneybag.purchase");
			case "7":
				return this.$t("moneybag.redPacket");
			case "8":
				return this.$t("moneybag.reward");
			case "9":
				return this.$t("moneybag.welfare");
			case "10":
				return this.$t("moneybag.invite");
			case "11":
			case "12":
				return this.$t("moneybag.income");
			default:
				return fallback;
			}
		},
		listd(type) {
			var dataf = this.data || [];

			for (var index = 0; index < dataf.length; index++) {
				if (type === 1) {
					dataf[index].show = 1;
				} else if (type === 2) {
					dataf[index].show = dataf[index].reason_type != 3 && dataf[index].reason_type != 4 ? 1 : 0;
				} else {
					dataf[index].show = dataf[index].reason_type == 3 || dataf[index].reason_type == 4 ? 1 : 0;
				}
			}

			this.data = dataf;
		},
		chooseType(val) {
			if (val == 0) {
				Fetch("/user/funds").then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			} else {
				Fetch("/user/funds", {
					reason_id: val,
				}).then(r => {
					this.data = r.data.list;
					this.showError(r.data.list.length);
				});
			}
		},
		formatFundAmount(item) {
			var amount = (1*item.money).toFixed(2);
			var prefix = item.type == "1" ? "+ " : "- ";

			if (isNaN(amount)) {
				amount = 0;
			}

			return prefix + amount;
		},
		showError(len) {
			this.listShow = len === 0;
		},
	},
};
</script>

<style lang="less" scoped>
.funds-page {
	min-height: 100vh;
	background: #111;
	color: #f6f6f6;
	padding-bottom: 80px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #111;
	color: #f6f6f6;
	border-bottom: 1px solid #242424;
	box-sizing: border-box;

	.back_left {
		filter: invert(1);
		opacity: 0.88;
	}

	.big_tit {
		color: #f6f6f6;
	}
}

.detail_box {
	padding: 16px 16px 0;
}

.record-card {
	margin-bottom: 14px;
	padding: 17px 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 12px;
	border: 1px solid #303030;
	background: #222;
	box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
	box-sizing: border-box;
}

.de_wrap {
	min-width: 0;
	flex: 1;
}

.tit {
	color: #f6f6f6;
	font-size: 14px;
	font-weight: 700;
	line-height: 22px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.time {
	margin-top: 8px;
	color: #9aa1aa;
	font-size: 12px;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.price {
	flex: 0 0 auto;
	max-width: 38%;
	margin-left: 14px;
	font-size: 16px;
	font-weight: 700;
	line-height: 24px;
	text-align: right;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.price.is-income {
	color: #12ed72;
}

.price.is-outcome {
	color: #ff4a4a;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description {
	color: #9aa1aa;
}


.basic_btn,
.history_coupon,
.wallet-btn.is-primary,
.allbtn {
  border: 0;
  background: linear-gradient(100deg, #657be9 0%, #8c52bd 100%) !important;
  color: #fff;
}


.page-top {
  background: #101010;
}

@media screen and (max-width: 374px) {
	.detail_box {
		padding-right: 12px;
		padding-left: 12px;
	}

	.record-card {
		padding-right: 14px;
		padding-left: 14px;
	}

	.price {
		max-width: 34%;
		font-size: 14px;
	}
}
</style>
